import { render, staticRenderFns } from "./PlayCollect.vue?vue&type=template&id=2b974a78&"
import script from "./PlayCollect.vue?vue&type=script&lang=js&"
export * from "./PlayCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports